import { DELETE, EDIT } from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'

export const TABLE_ACTIONS = Object.freeze([
  EDIT,
  DELETE,
])

const DATE_FORMAT = 'DD.MM.YYYY'

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: false,
    width: '60px',
  },
  {
    text: 'Дата',
    value: 'date',
    sortable: true,
    width: 136,
    field: (value: string) => value && dateFormatter(value, DATE_FORMAT),
  },
  {
    text: 'Лимит на дату',
    value: 'count',
    sortable: false,
  },
  {
    text: 'Лимит на ОО',
    value: 'school_count',
    sortable: false,
  },
  {
    text: 'Факт',
    value: 'fact_count',
    sortable: false,
  },
])
